import React from "react";
import { Navigate } from "react-router-dom";
import { getUser, setReturnURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const UserPrivateRoute = ({ component: Component }) => {
  return (
    <>
      {(function () {
        if (true) {
          return <Component />;
        } else {
          setReturnURL(ROLE.USER);
          return <Navigate to="/user/login" />;
        }
      })()}
    </>
  );
};

export default UserPrivateRoute;
